import { z } from "zod/v4";

import { ExperienceDtoSchema } from "../../../dtos/experiences";
import { OrgIdNameDtoSchema } from "../../../dtos/organization-name-id";
import { ExperienceWebhookActionTypeList } from "../../../dtos/webhooks";

export const CreateWebhookRequestBodySchema = z.object({
  actionTypes: z.enum(ExperienceWebhookActionTypeList).array(),
  url: z.url(),
  enabled: z.boolean().optional().default(true),
});

export type CreateWebhookRequestBodyType = z.infer<
  typeof CreateWebhookRequestBodySchema
>;

export const UpdateWebhookRequestBodySchema = z.object({
  webhookId: z.string(),
  url: z.url().optional(),
  enabled: z.boolean().optional(),
  actionTypes: z.enum(ExperienceWebhookActionTypeList).array().optional(),
});

export type UpdateWebhookRequestBodyType = z.infer<
  typeof UpdateWebhookRequestBodySchema
>;

export const DeleteWebhookRequestBodySchema = z.object({
  webhookId: z.string(),
});

export type DeleteWebhookRequestBodyType = z.infer<
  typeof DeleteWebhookRequestBodySchema
>;

export const TriggerExperienceWebhooksRequestBodySchema = z.object({
  actionType: z.enum(ExperienceWebhookActionTypeList),
  experience: ExperienceDtoSchema,
  org: OrgIdNameDtoSchema,
  by: z.string().nullish(),
});

export type TriggerWebhooksRequestBodyType = z.infer<
  typeof TriggerExperienceWebhooksRequestBodySchema
>;

export type CrudWebhookType =
  | CreateWebhookRequestBodyType
  | UpdateWebhookRequestBodyType
  | DeleteWebhookRequestBodyType;
